import { Component, computed, Signal, input, InputSignal } from '@angular/core';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { I18nService } from '@toteimlib/angular-lib';
import { MessageModule } from '@openng/optimus-ui/message';

@Component({
  selector: 't-input-error',
  imports: [MessageModule, TranslateModule],
  template: `
    <p-message severity="error" variant="simple" size="small">
      <span class="text-destructive" [translate]="translationKey()" [translateParams]="params()"></span>
    </p-message>
  `,
  styleUrls: []
})
export class InputErrorComponent {

  readonly translationKey: InputSignal<string> = input.required<string>();
  readonly fieldTranslationKey: InputSignal<string> = input<string>('');
  readonly translateParams: InputSignal<any> = input<any>({});

  locale: Signal<string>;

  params: Signal<any> = computed((): any => {
    this.locale();

    if (this.fieldTranslationKey()) {
      return {
        ...this.translateParams(),
        field: this.translateService.instant(this.fieldTranslationKey())
      };
    }

    return this.translateParams();
  });

  constructor(private translateService: TranslateService, private i18nService: I18nService) {
    this.locale = this.i18nService.getLocale();
  }

}
